import { IntegrationModel } from '@/types';

export interface OpenAiIntegrationModel extends IntegrationModel {
    token: string;
    model: string;
}
